import React from "react"
import { Redirect } from "react-router-dom"
// Dashboard
import DashboardIndex from "../pages/Dashboard/index"

// Authentication related pages
import Login from "../pages/Authentication/Login"

// GENERAL
import posIndex from "../pages/general/poses/Index"
import posIndexFast from "../pages/general/poses/IndexFast"
import posCreateUpdate from "../pages/general/poses/CreateUpdate"

import suppliersIndex from "../pages/general/suppliers/Index"

import clientsIndex from "../pages/general/clients/Index"
import myOrganizationUpdate from "../pages/general/myOrganization/CreateUpdate"

import productsIndex from "../pages/general/products/Index"
import productsCreateUpdate from "../pages/general/products/CreateUpdate"
import productCategoriesIndex from "../pages/general/productCategories/Index"

import accountManagerIndex from "../pages/general/accountManager/Index"
import planFactIndex from "../pages/general/planFact/Index"
import planPage from "../pages/general/planFact/Plan"
import faktPage from "../pages/general/planFact/Fakt"

import cashboxSettings from "../pages/general/cashboxSettings/Settings"
import didoxIndex from "../pages/general/didox/Index"

import notification from "../pages/general/notification/Notification"

import payments from "../pages/general/payments/Index"
import newPayments from "../pages/general/newPayments/Index"
import confirmPayments from "../pages/general/confirmPayments/Index"
import reportsMonthly from "../pages/general/reports/Index"
import reportsIntegration from "../pages/general/reportsIntegration/Index"
import reportsDealers from "../pages/general/reportsDealers/Index"
import reportsBonus from "../pages/general/reportsBonus/Index"

// ADMIN
import adminClientsIndex from "../pages/admin/clients/Index"
import debtorExcel from "../pages/admin/debtorExcel/Index"
import test from "../pages/test"
import Register from "pages/Authentication/Register"

const userRoutes = [
	{ path: "/dashboard", component: DashboardIndex },

	// GENERAL
	{ path: "/pos", component: posIndexFast },
	{ path: "/pos-full", component: posIndex },
	{ path: "/pos-create/:ownerLogin", component: posCreateUpdate },
	{ path: "/pos-update/:id", component: posCreateUpdate },

	{ path: "/clients", component: clientsIndex },

	{ path: "/my-organization", component: myOrganizationUpdate },

	{ path: "/suppliers", component: suppliersIndex },

	{ path: "/products", component: productsIndex },
	{ path: "/products-create", component: productsCreateUpdate },
	{ path: "/products-update/:id", component: productsCreateUpdate },

	{ path: "/product-categories", component: productCategoriesIndex },

	{ path: "/accountManager", component: accountManagerIndex },

	{ path: "/plan-fact", component: planFactIndex },
	{ path: "/plan", component: planPage },
	{ path: "/fakt", component: faktPage },

	{ path: "/cashboxSettings", component: cashboxSettings },

	{ path: "/didox", component: didoxIndex },

	{ path: "/notification", component: notification },

	{ path: "/payments", component: payments },
	{ path: "/newPayments", component: newPayments },
	{ path: "/confirmPayments", component: confirmPayments },
	{ path: "/reports-monthly", component: reportsMonthly },
	{ path: "/reports-integration", component: reportsIntegration },
	{ path: "/reports-dealers", component: reportsDealers },
	{ path: "/reports-bonus", component: reportsBonus },


	// ADMIN
	{ path: "/admin/clients", component: adminClientsIndex },
	{ path: "/admin/debt/excel", component: debtorExcel },
	{ path: "/test", component: test },

	// this route should be at the end of all other routes
	{ path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
	// 404 route not found
	{ path: "*", exact: true, component: () => <Redirect to="/dashboard" /> },
]

const authRoutes = [
	{ path: "/register", component: Register },
	{ path: "/login", component: Login },
]

export { userRoutes, authRoutes }